/**
 * RemoveConfirmModal — portal confirm dialog for removing a team member.
 * Extracted from TeamModal verbatim; overlay handlers/ref and the target
 * email/actions are passed in as props. Stateless.
 */

import React, { type RefObject } from 'react';
import { createPortal } from 'react-dom';

export function RemoveConfirmModal({
  email,
  portalRoot,
  modalRef,
  onOverlayMouseDown,
  onOverlayClick,
  onCancel,
  onConfirm,
}: {
  email: string;
  portalRoot: Element;
  modalRef: RefObject<HTMLDivElement>;
  onOverlayMouseDown: (e: React.MouseEvent) => void;
  onOverlayClick: (e: React.MouseEvent) => void;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return createPortal(
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
        zIndex: 20000, display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      onMouseDown={onOverlayMouseDown}
      onClick={onOverlayClick}
    >
      <div
        ref={modalRef}
        style={{
          background: 'var(--color-surface, #ffffff)', padding: '24px', borderRadius: '16px',
          maxWidth: '400px', width: '90%',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
          color: 'var(--color-text, #1a1a1a)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <p style={{ margin: '8px 0 24px', lineHeight: '1.5' }}>
          Are you sure you want to remove <strong>{email}</strong> from this workspace? They'll lose access immediately but any objects they created will remain.
        </p>
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '8px 16px', borderRadius: '8px', cursor: 'pointer',
              background: 'var(--color-action-cancel-bg)', border: '1px solid var(--color-border)',
              color: 'var(--color-text-primary)',
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '8px 16px', borderRadius: '8px', cursor: 'pointer',
              background: 'var(--color-danger)', border: 'none', color: '#fff',
            }}
          >
            Remove
          </button>
        </div>
      </div>
    </div>,
    portalRoot
  );
}
